export const env = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? 'https://api-staging.jiali.cn/v1',
  clientVersion: '0.1.0',
};
